import React from 'react';

class ErrorBoundary extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    // You can also log error to an external service here
  }

  render() {
    
      if (this.state.hasError) {
        return (
          <div style={{ padding: 20, color: 'red' }}>
            <h2>Something went wrong.</h2>
            <p>{this.state.error?.toString()}</p>
          </div>
        );
    ;
    }
  }
}

export default ErrorBoundary;
